import { FC } from 'react';
import { Hint } from 'components/common/Hint';
import { UiText } from '@frontend/znanie-uikit';
import cn from 'classnames';
import Image from 'next/legacy/image';

import * as C from './UserMultiplier.const';
import * as T from './UserMultiplier.types';
import css from './UserMultiplier.module.scss';

import LIGHTNING_IMAGE from './images/lightning.png';

export const UserMultiplier: FC<T.IUserMultiplier> = (props) => {
  return (
    <Hint
      content={
        <div className={css.hintContainer}>
          <UiText className={css.multiplier}>
            ×{props.multiplier || 1}{' '}
            <div className={css.imageWrapper}>
              <Image
                src={LIGHTNING_IMAGE}
                layout="fill"
                alt="Иллюстрация счетчика"
                objectFit="contain"
                objectPosition="top"
              />
            </div>
          </UiText>
          <UiText className={css.hintTitle}>Это множитель Знания.</UiText>
          <UiText className={css.hintText}>{C.HINT_TEXT}</UiText>
        </div>
      }
      orientation="right"
    >
      <UiText className={cn(css.container, css.multiplier, props.className)}>
        ×{props.multiplier || 1}{' '}
        <div className={css.imageWrapper}>
          <Image
            src={LIGHTNING_IMAGE}
            layout="fill"
            alt="Иллюстрация счетчика"
            objectFit="contain"
            objectPosition="top"
          />
        </div>
      </UiText>
    </Hint>
  );
};
